import { render, staticRenderFns } from "./faceDeviceReset.vue?vue&type=template&id=f4193d0c&scoped=true&"
import script from "./faceDeviceReset.vue?vue&type=script&lang=js&"
export * from "./faceDeviceReset.vue?vue&type=script&lang=js&"
import style0 from "./faceDeviceReset.vue?vue&type=style&index=0&id=f4193d0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4193d0c",
  null
  
)

export default component.exports